export default __webpack_public_path__ + "static/media/koho.e834c3fa.png";